import { GithubAuthProvider, signInWithPopup, signOut as firebaseSignOut } from 'firebase/auth';
import { auth as firebaseAuth, db } from '../config/firebase';
import { doc, setDoc } from "firebase/firestore";
import { logEvent } from "./analytics";
export async function signInWithGitHub() {
    const provider = new GithubAuthProvider();
    provider.addScope("read:org");
    const result = await signInWithPopup(firebaseAuth, provider);
    const credential = GithubAuthProvider.credentialFromResult(result);
    const tokenToSave = credential === null || credential === void 0 ? void 0 : credential.accessToken;
    await saveAccessToken(result.user, tokenToSave);
    logEvent("login");
    // Wait for .5 seconds for the db to be up to date
    return new Promise(resolve => setTimeout(resolve, 500));
}
export async function signOut() {
    logEvent('signed_out');
    return firebaseSignOut(firebaseAuth);
}
export async function saveAccessToken(user, accessToken) {
    await setDoc(doc(db, "users", user.uid), {
        token: accessToken,
        date: new Date(),
    });
    logEvent('save_key');
}
